import React from 'react';
import Hero from './components/sahityik-sanskritik-parishad/Hero';
import Main from './components/sahityik-sanskritik-parishad/Main';

const SahityikSanskritikParishad = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default SahityikSanskritikParishad;